module.exports = __webpack_public_path__ + "static/media/PM25.5d597a24.JPG";